var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _g, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgErrorMessageContainer = function SvgErrorMessageContainer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 455 260"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ECEDEE",
    fillRule: "evenodd",
    d: "M201.374 218.806s-60.417-2.97-72.21 15.059c-4.188 6.401-17.812 2.015-6.224-4.348 11.908-6.541 25.258-13.469 64.985-12.409l13.449 1.698Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#D3D4D5",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M120.374 232.494c16.815-13.305 49.26-15.415 74.647-14.624 0 0 52.449 3.872 105.458 12.687 11.665 1.939 23.112 2.258 32.543 2.443 32.086-.637 72.348-7.26 80.352-37"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E7E8E9",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M292.874 152.094c32.343 5.269 87.908 20.466 112.277 33.535A11.771 11.771 0 0 1 411.374 196M350.874 189v9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E7E8E9",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M356.333 183.665c.446 2.943-2.9 5.335-6.479 5.335-3.578 0-6.48-2.388-6.48-5.335s4.461-11.838 7.079-7.488c2.022 3.359 5.195 2.968 5.88 7.488Z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E7E8E9",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M365.874 180v18"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M379.286 164.084C377.938 172.209 373.263 179 365.83 179c-7.432 0-13.456-6.677-13.456-14.916 0-8.238 6.359-31.83 11.796-19.668 4.198 9.389 16.349 12.241 15.116 19.668Z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E7E8E9",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M379.286 164.084C377.938 172.209 373.263 179 365.83 179c-7.432 0-13.456-6.677-13.456-14.916 0-8.238 6.359-31.83 11.796-19.668 4.198 9.389 16.349 12.241 15.116 19.668Z",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#D3D4D5",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M389.374 236c16.496-9.543 29-22.57 29-40.26 0-3.751-5.881-3.74-5.881-3.74"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E7E8E9",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M411.374 191s13.052.923 19 9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECEDEE",
    fillRule: "evenodd",
    d: "M335.374 213c0 .552-2.911 1-6.499 1-3.591 0-6.501-.448-6.501-1 0-.553 2.91-1 6.501-1 3.588 0 6.499.447 6.499 1Z",
    clipRule: "evenodd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M340.374 203.197c0 4.862-4.477 8.803-10 8.803s-10-3.941-10-8.803c0-4.863 3.644-4.009 10-8.804 6.357-4.795 10 3.941 10 8.804Z",
    clipRule: "evenodd"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    stroke: "#D3D4D5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.025,
    d: "M340.374 203.197c0 4.862-4.477 8.803-10 8.803s-10-3.941-10-8.803c0-4.863 3.644-4.009 10-8.804 6.357-4.795 10 3.941 10 8.804Z",
    clipRule: "evenodd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECEDEE",
    fillRule: "evenodd",
    d: "M313.374 213c0 .552-2.239 1-5 1-2.762 0-5-.448-5-1s2.238-1 5-1c2.761 0 5 .448 5 1Z",
    clipRule: "evenodd"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M317.374 204.553c0 3.56-3.582 6.447-7.999 6.447-4.42 0-8.001-2.887-8.001-6.447 0-3.562 3.485-10.178 8.001-6.447 3.55 3.932 7.999 2.885 7.999 6.447Z",
    clipRule: "evenodd"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    stroke: "#D3D4D5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.025,
    d: "M317.374 204.553c0 3.56-3.582 6.447-7.999 6.447-4.42 0-8.001-2.887-8.001-6.447 0-3.562 3.485-10.178 8.001-6.447 3.55 3.932 7.999 2.885 7.999 6.447Z",
    clipRule: "evenodd"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECEDEE",
    fillRule: "evenodd",
    d: "M323.266 198.697s2.869-2.054 4.507.89c1.639 2.943.684 10.54 5.601 9.786-1.776.481-4.986 1.644-9.015-1.368-4.03-3.012-3.552-7.733-1.093-9.308Zm-19.473 2.826s2.152-1.54 3.381.667c1.229 2.207.513 7.904 4.2 7.341-1.332.359-3.739 1.232-6.761-1.027-3.023-2.259-2.665-5.8-.82-6.981Z",
    clipRule: "evenodd"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3F4F5",
    fillRule: "evenodd",
    d: "M346.114 181s1.783.641 2.537 3.224c.758 2.584 2.362 4.047 3.723 3.592-2.193.607-9.288.041-6.26-6.816Zm7.731-21s5.66 2.152 7.297 7.735c1.637 5.583 7.284 9.826 10.232 8.841-5.652 4.054-20.861-.268-17.529-16.576Z",
    clipRule: "evenodd"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECEDEE",
    fillRule: "evenodd",
    d: "M319.374 239c0 .552.671 1 1.5 1 .827 0 1.5-.448 1.5-1s-.673-1-1.5-1c-.829 0-1.5.448-1.5 1Z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "error-messageContainer_svg__a",
    width: 4,
    height: 2,
    x: 362,
    y: 243,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M362.57 243.34h2.95V245h-2.95v-1.66Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#error-messageContainer_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ECEDEE",
    fillRule: "evenodd",
    d: "M362.57 244.17c0 .458.66.83 1.475.83.815 0 1.475-.372 1.475-.83 0-.458-.66-.83-1.475-.83-.815 0-1.475.372-1.475.83Z",
    clipRule: "evenodd"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECEDEE",
    fillRule: "evenodd",
    d: "M336.374 236.5c0 .276.448.5.999.5.552 0 1.001-.224 1.001-.5s-.449-.5-1.001-.5c-.551 0-.999.224-.999.5Zm-156-11.5c0 .552.671 1 1.501 1 .827 0 1.499-.448 1.499-1s-.672-1-1.499-1c-.83 0-1.501.448-1.501 1Zm-28 3c0 .552 1.343 1 3 1 1.656 0 3-.448 3-1s-1.344-1-3-1c-1.657 0-3 .448-3 1Zm13 3c0 .552 1.343 1 2.999 1 1.657 0 3.001-.448 3.001-1s-1.344-1-3.001-1c-1.656 0-2.999.448-2.999 1Zm-24 7c0 .553.671 1 1.499 1 .829 0 1.501-.447 1.501-1 0-.553-.672-1-1.501-1-.828 0-1.499.447-1.499 1Zm167-2c0 .552 1.343 1 3 1 1.656 0 3-.448 3-1s-1.344-1-3-1c-1.657 0-3 .448-3 1Zm-12 4c0 .552 1.343 1 3 1 1.656 0 3-.448 3-1s-1.344-1-3-1c-1.657 0-3 .448-3 1Z",
    clipRule: "evenodd"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3F4F5",
    fillRule: "evenodd",
    d: "M140.374 156s-69.922 15.742-89.806 36.516c-9.972 10.419-35.804 4.107-22.437-3.37 18.074-10.113 67.314-28.5 102.842-32.792l9.401-.354Z",
    clipRule: "evenodd"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECEDEE",
    fillRule: "evenodd",
    d: "M74.374 186.5c0 .276-1.792.5-4 .5-2.209 0-4-.224-4-.5s1.791-.5 4-.5c2.208 0 4 .224 4 .5Zm15 1c0 .276-1.792.5-4 .5-2.209 0-4-.224-4-.5s1.791-.5 4-.5c2.208 0 4 .224 4 .5Z",
    clipRule: "evenodd"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E7E8E9",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M162.179 152.094C120.672 156.821 57.672 170.907 27.374 189"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECEDEE",
    fillRule: "evenodd",
    d: "M134.374 209c0 .552-2.911 1-6.499 1-3.591 0-6.501-.448-6.501-1 0-.553 2.91-1 6.501-1 3.588 0 6.499.447 6.499 1Z",
    clipRule: "evenodd"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M140.374 199.197c0 4.862-4.477 8.803-10 8.803s-10-3.941-10-8.803c0-4.863 3.643-4.009 10-8.804s10 3.941 10 8.804Z",
    clipRule: "evenodd"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    stroke: "#D3D4D5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.025,
    d: "M140.374 199.197c0 4.862-4.477 8.803-10 8.803s-10-3.941-10-8.803c0-4.863 3.643-4.009 10-8.804s10 3.941 10 8.804Z",
    clipRule: "evenodd"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECEDEE",
    fillRule: "evenodd",
    d: "M110.374 213c0 .552-2.239 1-5 1-2.762 0-5-.448-5-1s2.238-1 5-1c2.761 0 5 .448 5 1Z",
    clipRule: "evenodd"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M114.374 204.553c0 3.561-3.582 6.447-7.999 6.447-4.42 0-8.001-2.886-8.001-6.447 0-3.562 3.485-10.178 8.001-6.447 3.55 3.932 7.999 2.885 7.999 6.447Z",
    clipRule: "evenodd"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    stroke: "#D3D4D5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.025,
    d: "M114.374 204.553c0 3.561-3.582 6.447-7.999 6.447-4.42 0-8.001-2.886-8.001-6.447 0-3.562 3.485-10.178 8.001-6.447 3.55 3.932 7.999 2.885 7.999 6.447Z",
    clipRule: "evenodd"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECEDEE",
    fillRule: "evenodd",
    d: "M123.266 195.697s2.869-2.054 4.508.89c1.638 2.942.683 10.541 5.6 9.787-1.776.48-4.987 1.643-9.015-1.368-4.03-3.012-3.552-7.735-1.093-9.309Zm-22.473 5.826s2.152-1.54 3.381.667c1.229 2.207.512 7.906 4.2 7.341-1.332.359-3.738 1.232-6.762-1.027-3.022-2.259-2.664-5.8-.819-6.981Z",
    clipRule: "evenodd"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M78.334 173.665c.445 2.943-2.9 5.335-6.48 5.335-3.578 0-6.48-2.388-6.48-5.335 0-2.946 4.462-11.838 7.08-7.488 2.021 3.36 5.196 2.968 5.88 7.488Z",
    clipRule: "evenodd"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E7E8E9",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M78.334 173.665c.445 2.943-2.9 5.335-6.48 5.335-3.578 0-6.48-2.388-6.48-5.335 0-2.946 4.462-11.838 7.08-7.488 2.021 3.36 5.196 2.968 5.88 7.488Z",
    clipRule: "evenodd"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E7E8E9",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M85.874 169v18M71.874 179v7"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M99.35 154.29c-.416 8.176-4.712 14.71-12.277 14.71-7.566 0-13.7-6.636-13.7-14.823 0-8.186 8.329-51.223 13.215-32.507 4.67 17.888 13.303 21.924 12.761 32.62Z",
    clipRule: "evenodd"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E7E8E9",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M99.35 154.29c-.416 8.176-4.712 14.71-12.277 14.71-7.566 0-13.7-6.636-13.7-14.823 0-8.186 8.329-51.223 13.215-32.507 4.67 17.888 13.303 21.924 12.761 32.62Z",
    clipRule: "evenodd"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3F4F5",
    fillRule: "evenodd",
    d: "M67.114 170s1.781.642 2.537 3.224c.758 2.583 2.36 4.046 3.723 3.592-2.193.607-9.288.04-6.26-6.816Zm7.731-20s5.659 2.152 7.296 7.735c1.638 5.583 7.284 9.826 10.233 8.841-5.654 4.054-20.86-.268-17.528-16.576ZM273.021 188.981c0 2.751-20.516 4.981-45.824 4.981-25.309 0-45.823-2.23-45.823-4.981 0-2.75 20.514-4.981 45.823-4.981 25.308 0 45.824 2.231 45.824 4.981Z",
    clipRule: "evenodd"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#A0148C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M153.872 183.399 227.84 59.874l72.469 123.525H153.872Z",
    clipRule: "evenodd"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFBEDF",
    fillRule: "evenodd",
    d: "M212.266 169.446c1.886 1.444 3.168 2.591 3.096 4.988-3.586-.239-44.699-.38-44.555-.645 7.879-14.396 54.755-92.03 57.162-95.984 4.869 8.416-2.592 18.59-5.281 23.059-8.947 14.873-17.878 30.686-22.495 47.589-2.346 8.59 4.927 15.531 12.073 20.993Z",
    clipRule: "evenodd"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    stroke: "#A0148C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m169.811 174.433 57.363-96.628 56.2 96.628H169.811Z",
    clipRule: "evenodd"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#FACCB2",
    fillRule: "evenodd",
    d: "M222.657 154.353c-.578 4.46.767 7.073 4.035 7.84 3.268.767 5.52.066 6.755-2.101-1.515 4.203-4.365 5.604-8.548 4.203-4.184-1.402-4.931-4.715-2.242-9.942Zm-1.963-42.376c1.441 19.851 3.027 30.407 4.761 31.668 1.733 1.261 4.375 1.565 7.924.913.28.136-.305.808-1.756 2.013-1.451 1.206-3.901 1.507-7.348.905-1.924-.938-2.886-3.675-2.886-8.213 0-4.538-.232-13.633-.695-27.286Z",
    clipRule: "evenodd"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    stroke: "#D93923",
    strokeWidth: 2,
    d: "M227.589 165.464c3.574 0 6.471-2.926 6.471-6.535s-2.897-6.535-6.471-6.535c-3.574 0-6.471 2.926-6.471 6.535s2.897 6.535 6.471 6.535Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    stroke: "#D93923",
    strokeWidth: 2,
    d: "M230.214 108.69c1.381 0 2.631.56 3.536 1.464a4.986 4.986 0 0 1 1.464 3.51l-1.588 28.991a4.986 4.986 0 0 1-1.555 3.356 4.987 4.987 0 0 1-3.437 1.369h-2.091a4.985 4.985 0 0 1-3.437-1.369 4.987 4.987 0 0 1-1.556-3.356l-1.58-28.69a4.983 4.983 0 0 1 1.268-3.611 4.984 4.984 0 0 1 3.424-1.655l5.552-.009Z",
    clipRule: "evenodd"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FACCB2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m278.892 47.92-7.97 7.969M267.934 39.95l-5.977 8.966M254.982 31.981l-4.98 10.958M241.036 27.996l-1.992 10.958M226.593 27v11.954M212.147 27.996l1.993 10.958M198.202 31.981l4.981 10.958M187.244 39.95l5.977 8.966M175.29 47.92l7.969 7.969"
  })));
};
export default SvgErrorMessageContainer;